module.exports = __webpack_public_path__ + "img/hr-stone-path-outer-corner.3d75e3b1.png";